import { Pipe, PipeTransform } from '@angular/core';
import { ProductCatalogSource } from '../Services/products.service';

@Pipe({
  name: 'catalogLabel',
  standalone: true,
})
export class CatalogLabelPipe implements PipeTransform {
  transform(source: ProductCatalogSource): string {
    return source === ProductCatalogSource.CdData ? 'UK' : 'Irish';
  }
}
